import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import Index from './screen/Index';
import Login from './screen/Login';
import Welcome from './screen/Welcome';
import Introduce from './screen/Introduce';
import Story from './screen/Story';
import Zerotoone from './screen/ZeroToOne';
import StoryModel from './screen/StoryModel';
import BigStory from './screen/BigStory';
import Improve from './screen/improve';
import Twice from './screen/Twice';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
        <Route path="/twice" component={Twice} />
        <Route path="/improve" component={Improve} />
        <Route path="/bigstory" component={BigStory} />
        <Route path="/storymodel" component={StoryModel} />
        <Route path="/zerotoone" component={Zerotoone} />
        <Route path="/story" component={Story} />
        <Route path="/introduce" component={Introduce} />
          <Route path="/login" component={Login} />
          <Route path="/" component={Welcome} />
        </Switch>
      </Router>  
    );
  }
}

export default App;